// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"289":"administration","809":"account"}[chunkId] + "." + {"289":"60f48c27","809":"3edf1a69"}[chunkId] + ".chunk.js";
};